module.exports = __webpack_public_path__ + "img/ai.2bb08d7.svg";